__turbopack_context__.v({
  "spacer": "HeaderLogos-module__72CAmW__spacer",
  "trustpilot": "HeaderLogos-module__72CAmW__trustpilot",
});
